/**
 * Filename: 全局组件
 *
 * description: 组件的name项必写
 */

import Vue from 'vue';

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

const requireComponent = require.context(
    '@/components/', // 需要读取模块的文件的所在目录
    true, // 是否遍历子目录
    /\.vue$/ // 匹配的规则（正则表达式）
);

/* 引用全部以cl开头的文件夹中的组件 */
requireComponent.keys().forEach(fileName => {
    if (fileName.startsWith('./cl')) {
        const componetConfig = requireComponent(fileName);
        let a = fileName.lastIndexOf('/');
        fileName = '.' + fileName.slice(a);
        const componetName = capitalizeFirstLetter(
            fileName.replace(/^\.\//, '').replace(/\.\w+$/, '')
        );
        Vue.component(
            componetConfig.default.name || componetName,
            componetConfig.default || componetConfig
        );
    }
});
